import { message } from 'antd';
import {
  fetchTransferStandardBatchUpdate,
  fetchTransferStandardDeleteByCenterCode,
  fetchTransferStandardExecute,
  fetchTransferStandardExport,
  fetchTransferStandardGetConfig,
  fetchTransferStandardImport,
  fetchTransferStandardPage,
  fetchTransferStandardSaveConfig,
  fetchTransferStandardUpdate,
} from '@/services/cityToCityTransferStandard';

export default {
  namespace: 'transferStandardTable',
  state: {
    searchParams: {},
    list: [],
    total: 0,
    configTimelinessList: [],
    pushConfigList: [],
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      const result = yield call(fetchTransferStandardPage, payload);
      yield put({
        type: 'updateState',
        payload: {
          searchParams: payload || {},
          list: result?.data?.rows || [],
          total: result?.data?.total || 0,
        },
      });
    },
    *fetchConfigTimelinessList(_, { call, put }) {
      const payload = {
        centerCode: null,
        centerName: null,
        page: 1,
        pageSize: 200,
      };
      const result = yield call(fetchTransferStandardPage, payload);
      yield put({
        type: 'updateState',
        payload: {
          configTimelinessList: result?.data?.rows || [],
        },
      });
      return result;
    },
    *batchUpdate({ payload }, { call }) {
      const result = yield call(fetchTransferStandardBatchUpdate, payload);
      if (result?.code === 1) {
        message.success(result?.message || '保存成功');
      }
      return result;
    },
    *update({ payload }, { call }) {
      const result = yield call(fetchTransferStandardUpdate, payload);
      if (result?.code === 1) {
        message.success(result?.message || '保存成功');
      }
      return result;
    },
    *importData({ payload }, { call }) {
      const result = yield call(fetchTransferStandardImport, payload);
      if (result?.code === 1 && !result?.data?.length) {
        message.success(result?.message || '导入成功');
      }
      return result;
    },
    *remove({ payload }, { call }) {
      const result = yield call(fetchTransferStandardDeleteByCenterCode, payload);
      if (result?.code === 1) {
        message.success(result?.message || '删除成功');
      }
    },
    *exportData({ payload }, { call }) {
      yield call(fetchTransferStandardExport, payload);
    },
    *getPushConfig({ payload }, { call, put }) {
      const result = yield call(fetchTransferStandardGetConfig, payload);
      yield put({
        type: 'updateState',
        payload: {
          pushConfigList: result?.data || [],
        },
      });
      return result;
    },
    *savePushConfig({ payload }, { call }) {
      const result = yield call(fetchTransferStandardSaveConfig, payload);
      if (result?.code === 1) {
        message.success(result?.message || '保存成功');
      }
      return result;
    },
    *executeData(_, { call }) {
      const result = yield call(fetchTransferStandardExecute);
      if (result?.code === 1) {
        message.success(result?.message || '执行成功');
      }
      return result;
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
